export default __webpack_public_path__ + "alberta-shoppingcart-full.1cfa78eb25a554538084.svg";